var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/CheckBox/Selected-focused") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,6 C22,3.61831856 20.2120018,2 18,2 L6,2 C3.79086,2 2,3.79086 2,6 L2,18 C2,20.2091 3.79086,22 6,22 L18,22 C20.2091,22 22,20.2091 22,18 L22,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/CheckBox/Selected-focused",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#670041",
    d: "M18,1.5 C19.2666706,1.5 20.4069106,1.97658542 21.2228162,2.79249104 C22.0096231,3.57929792 22.5,4.68446022 22.5,6 L22.5,6 L22.5,18 C22.5,19.2426188 21.9963117,20.3676201 21.1819659,21.1819659 C20.3676201,21.9963117 19.2426188,22.5 18,22.5 L18,22.5 L6,22.5 C4.75736421,22.5 3.63236806,21.9963148 2.81802894,21.1819757 C2.0036826,20.3676294 1.5,19.2426242 1.5,18 L1.5,18 L1.5,6 C1.5,4.75735875 2.00367943,3.63235878 2.81801911,2.81801911 C3.63235878,2.00367943 4.75735875,1.5 6,1.5 L6,1.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#901356",
    d: "M18,2.5 C18.9861425,2.5 19.8788188,2.86270718 20.5157094,3.49959782 C21.1290619,4.11295032 21.5,4.97780022 21.5,6 L21.5,6 L21.5,18 C21.5,18.9664812 21.1082383,19.8414799 20.4748591,20.4748591 C19.8414799,21.1082383 18.9664813,21.5 18,21.5 L18,21.5 L6,21.5 C5.03350579,21.5 4.15851005,21.1082433 3.52513572,20.4748689 C2.89175551,19.8414887 2.5,18.9664858 2.5,18 L2.5,18 L2.5,6 C2.5,5.03350125 2.89175057,4.15850122 3.52512589,3.52512589 C4.15850122,2.89175057 5.03350125,2.5 6,2.5 L6,2.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,6 C22,3.61831856 20.2120018,2 18,2 L6,2 C3.79086,2 2,3.79086 2,6 L2,18 C2,20.2091 3.79086,22 6,22 L18,22 C20.2091,22 22,20.2091 22,18 L22,6 Z M18.7508062,8.59742982 L10.6280994,17.5290925 C10.2380994,17.9167925 9.60809938,17.9167925 9.21809938,17.5290925 L5.29497938,13.6290925 C4.90330938,13.2396925 4.90143938,12.6065925 5.29080938,12.2148925 C5.68017938,11.8231925 6.31333938,11.8212925 6.70501938,12.2106925 L9.92309938,15.4097925 L17.3704732,7.39014299 C17.7381087,7.0424038 18.2680124,6.75961644 18.7508062,7.30889947 C19.0726687,7.67508816 19.0726687,8.10459827 18.7508062,8.59742982 Z",
    id: "Shape",
    fill: "#901356"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedFocused);
export default __webpack_public_path__ + "static/media/selected-focused.730eec84.svg";
export { ForwardRef as ReactComponent };